/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ImageCarouselIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Image Carousel',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="22" rx="1" ry="1" width="24" x="6" y="2" />
    <path
      d="M4 22H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3ZM35 22h-3V6h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1Z"
    />
    <circle cx="8" cy="30" r="1.4" />
    <circle cx="14" cy="30" r="2.1" />
    <circle cx="20" cy="30" r="1.4" />
    <circle cx="26" cy="30" r="1.4" />
  </svg>`;
};
